import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadExemptionCertificates from "@thkStore/Store/Widgets/ExemptionCertificateList/Handlers/LoadExemptionCertificates";

interface Parameter {
    // Vertex uuids of the certificates just uploaded via the wizard.
    uuids: string[];
    pageSize?: number;
}

type HandlerType = Handler<Parameter>;

// A newly uploaded certificate is synced into the local DB by a queued batch job, so it is
// not available immediately. Poll page 1 (newest first) until it appears, or give up after
// the timeout window and let the scheduled sync be the backstop.
const POLL_INTERVAL_MS = 3000;
const MAX_ATTEMPTS = 12;

const delay = (ms: number) => new Promise<void>(resolve => setTimeout(resolve, ms));

export const BeginAwaitUploadSync: HandlerType = props => {
    props.dispatch({
        type: "Widgets/ExemptionCertificateList/BeginAwaitUploadSync",
    });
};

export const PollUntilCertificatesAppear: HandlerType = async props => {
    const pageSize = props.parameter.pageSize || 10;
    const expectedUuids = props.parameter.uuids || [];

    for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
        // Reloading the shared list slice refreshes the grid the user is looking at.
        props.dispatch(loadExemptionCertificates({ page: 1, pageSize }));

        await delay(POLL_INTERVAL_MS);

        const certificates = (props.getState() as any).exemptionCertificateList?.certificates || [];
        const found =
            expectedUuids.length === 0 ||
            certificates.some((c: any) => expectedUuids.indexOf(c.uuid) >= 0);

        if (found) {
            return;
        }
    }
};

export const EndAwaitUploadSync: HandlerType = props => {
    props.dispatch({
        type: "Widgets/ExemptionCertificateList/EndAwaitUploadSync",
    });
};

export const chain = [BeginAwaitUploadSync, PollUntilCertificatesAppear, EndAwaitUploadSync];

const refreshCertificatesAfterUpload = createHandlerChainRunner(chain, "RefreshCertificatesAfterUpload");
export default refreshCertificatesAfterUpload;
